'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = require('../../lib/Select');

var _Select2 = _interopRequireDefault(_Select);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'select': 'Default__select___Uuaqu'
};

var DefaultSelect = (0, _mergeThemeHoc2.default)(style)(_Select2.default);
DefaultSelect.displayName = 'DefaultSelect';
exports.default = DefaultSelect;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/dist/Select/index.js
// module id = 761
// module chunks = 4 5 8 9 14